var React = require('react');

function MobileLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 39a1 1 0 011-1h26a1 1 0 110 2H11a1 1 0 01-1-1z","key":0}),React.createElement("path",{"d":"M24 42.5a.5.5 0 110 1 .5.5 0 010-1z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 43.5a.5.5 0 100-1 .5.5 0 000 1zm-1.06-1.56a1.5 1.5 0 112.12 2.12 1.5 1.5 0 01-2.12-2.12z","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 1a1 1 0 011-1h26a1 1 0 011 1v46a1 1 0 01-1 1H11a1 1 0 01-1-1V1zm2 1v44h24V2H12z","key":3})]);
}

MobileLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = MobileLight;

MobileLight.default = MobileLight;
